export const featureFlags = {
  enableOwnerGroupPage: true,
};
